import {
  Box, DashboardModule,
} from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import usePriceListItems from '@hooks/usePriceListItems'

import PriceListItemListItem from './PriceListItemListItem'

const buildPageFilterFields = () => {
  const style = { marginBottom: 16 }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'priceListName',
      label: 'Filter by Name',
    },
  ]
}

interface PriceListItemsProps {
  productId: number,
}

const PriceListItems = (props: PriceListItemsProps) => {
  const { productId } = props

  const filterPayload = useFilters()

  const {
    pageFilters,
  } = filterPayload

  const options = {
    filters: { productId, ...pageFilters },
    performHttpRequests: !!productId,
    requestOptions: {
      include: 'PriceList',
    },
  }

  const priceListItemsPayload = usePriceListItems(options)

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredPriceListItems,
    filteredPriceListItemsCount,
    hasFilteredPriceListItems,
    loading,
  } = priceListItemsPayload

  return (
    <DashboardModule
      boxProps={{ borderBottom: loading && !hasFilteredPriceListItems ? 'none' : '1px solid lineColor' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Price Lists"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      <Box flexDirection="column">
        <DashboardModule.ScrollableSection flexDirection="column">
          {!loading && !hasFilteredPriceListItems && (
            <DashboardModule.BlankState>
              <DashboardModule.BlankState.Title>
                Please adjust your filters or link a Price List
              </DashboardModule.BlankState.Title>
            </DashboardModule.BlankState>
          )}

          {!loading && filteredPriceListItems.map(priceListItem => (
            <PriceListItemListItem
              key={priceListItem.id}
              priceListItem={priceListItem}
            />
          ))}
        </DashboardModule.ScrollableSection>

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredPriceListItemsCount}
          loading={loading}
        />
      </Box>
    </DashboardModule>
  )
}

export default PriceListItems
